import clsx from 'clsx'
import { Container, Icon } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import styles from 'modules/Finance/Wallets/subcomponents/PromisedPayments/subcomponents/StatusIcon/status-icon.module.scss'

const StatusIcon = ({ status, breakpoints }) => {
  const iconConf = useMemo(() => {
    switch (status) {
      case 'pending':
        return { name: 'transaction pending', color: 'secondary-69' }
      case 'repaid':
      case 'approved':
        return { name: 'transaction paid', color: 'secondary-11' }
      case 'declined':
        return { name: 'transaction canceled', color: 'secondary-46' }
      default:
        return { name: 'transaction new', color: 'secondary-grey' }
    }
  }, [status])

  return (
    <Container
      display={'flex'}
      className={clsx(styles['container'], {
        [styles['container_' + status]]: status,
        [styles['container_small']]: breakpoints.sm,
      })}
    >
      <Icon
        size={'as-is'}
        name={iconConf.name}
        className={clsx(styles['icon'])}
        color={iconConf.color}
      />
    </Container>
  )
}

StatusIcon.propTypes = {
  status: PropTypes.oneOf(['new', 'pending', 'approved', 'declined', 'repaid']),
  breakpoints: PropTypes.object,
}

export default StatusIcon
